<div class="avatar-container" [ngClass]="{'l': size() === 'l'}">
  <span>{{ displayInitials }}</span>
</div>
